import Image101 from "../../assets/images/tax-portal/tax-consulting/icons/양도.png";
import Image102 from "../../assets/images/tax-portal/tax-consulting/icons/상속증여.png";
import Image103 from "../../assets/images/tax-portal/tax-consulting/icons/법인전환.png";
import Image104 from "../../assets/images/tax-portal/tax-consulting/icons/자기주식.png";
import Image105 from "../../assets/images/tax-portal/tax-consulting/icons/주식 명의신탁.png";
import Image106 from "../../assets/images/tax-portal/tax-consulting/icons/주식양수도.png";
import Image107 from "../../assets/images/tax-portal/tax-consulting/icons/상속증여.png";
import Image108 from "../../assets/images/tax-portal/tax-consulting/icons/미처분 이익잉여금 관리.png";
import Image109 from "../../assets/images/tax-portal/tax-consulting/icons/가지급금 관리.png";
import Image110 from "../../assets/images/tax-portal/tax-consulting/icons/가업승계.png";

import Image201 from "../../assets/images/tax-portal/tax-consulting/icons/산업재산권.png";
import Image202 from "../../assets/images/tax-portal/tax-consulting/icons/사내근로복지기금.png";
import Image203 from "../../assets/images/tax-portal/tax-consulting/icons/기업인증.png";
import Image204 from "../../assets/images/tax-portal/tax-consulting/icons/벤처기업.png";
import Image205 from "../../assets/images/tax-portal/tax-consulting/icons/연구소.png";
import Image206 from "../../assets/images/tax-portal/tax-consulting/icons/자금조달.png";
import Image207 from "../../assets/images/tax-portal/tax-consulting/icons/기업신용등급관리.png";

import Image301 from "../../assets/images/tax-portal/tax-consulting/icons/인력관리.png";
import Image302 from "../../assets/images/tax-portal/tax-consulting/icons/채용 및 통합.png";
import Image303 from "../../assets/images/tax-portal/tax-consulting/icons/보상 및 혜택.png";
import Image304 from "../../assets/images/tax-portal/tax-consulting/icons/직원개발.png";
import Image305 from "../../assets/images/tax-portal/tax-consulting/icons/조직문화 및 관리.png";

import Image401 from "../../assets/images/tax-portal/tax-consulting/icons/보험.png";
import Image402 from "../../assets/images/tax-portal/tax-consulting/icons/주식.png";
import Image403 from "../../assets/images/tax-portal/tax-consulting/icons/채권.png";
import Image404 from "../../assets/images/tax-portal/tax-consulting/icons/외환.png";
import Image405 from "../../assets/images/tax-portal/tax-consulting/icons/상품.png";



export const TAX_CONSULTING_CATEGORY_INFO = [
  {
    label: "양도",
    icon: Image101
  },
  {
    label: "상속 증여",
    icon: Image102
  },
  {
    label: "법인전환",
    icon: Image103
  },
  {
    label: "자기주식",
    icon: Image104
  },
  {
    label: "주식 명의신탁",
    icon: Image105
  },
  {
    label: "주식 양수도",
    icon: Image106
  },
  {
    label: "주식 상속 증여",
    icon: Image107
  },
  {
    label: "미처분 이익잉여금 관리",
    icon: Image108
  },
  {
    label: "가지급금 관리",
    icon: Image109
  },
  {
    label: "가업승계",
    icon: Image110
  },
  { label: "산업재산권", icon: Image201 },
  { label: "사내근로복지기금", icon: Image202 },
  { label: "기업 인증", icon: Image203 },
  { label: "벤처기업", icon: Image204 },
  { label: "연구소", icon: Image205 },
  { label: "자금조달", icon: Image206 },
  { label: "기업신용등급관리", icon: Image207 },

  { label: "인력관리", icon: Image301 },
  { label: "채용 및 통합", icon: Image302 },
  { label: "보상 및 혜택", icon: Image303 },
  { label: "직원개발", icon: Image304 },
  { label: "조직 문화 및 관리", icon: Image305 },


  { label: "보험", icon: Image401 },
  { label: "주식", icon: Image402 },
  { label: "채권", icon: Image403 },
  { label: "외환", icon: Image404 },
  { label: "상품", icon: Image405 },
];

export const VISIBILITY_TYPES = [
  { label: "전체", value: "public" },
  { label: "접근자 제한", value: "restricted" },
  { label: "나와 관리자만 보기", value: "personal" },
];

export const ROLE_TYPES = [
  { label: "목록읽기", value: "READ_LIST" },
  { label: "읽기", value: "READ" },
  { label: "쓰기", value: "WRITE" },
];

export const COMPANY_EXPOSURE_TYPES = [
  { label: "전체 회사", value: 'ALL' },
  { label: "세무 회사", value: 'TAX' },
  { label: "노무 회사", value: 'LABOR' },
  { label: "지정 회사", value: 'DESIGNATED' },
];
export const EMPLOYEE_EXPOSURE_TYPES = [
  { label: "전직원", value: 'ALL' },
  { label: "대표자", value: 'CEO' },
  // { label: "세무사", value: 'TAX' },
  // { label: "대표자 & 세무사", value: 'CEO_AND_TAX' },
  { label: "지정 직원", value: 'DESIGNATED' },
];

export const BOARD_OPTIONS = [
  [
    { label: "내용", value: "content" },
    { label: "코멘트", value: "comment" },
  ],
  [
    { label: "파일첨부", value: "file" }
  ]
];

export const DEFAULT_ROLE_TYPE = [
  { label: "목록읽기", value: "READ_LIST" },
  { label: "읽기", value: "READ" },
  { label: '노출 안함', value: "NONE" },
];
